import { render, staticRenderFns } from "./IconContrast.vue?vue&type=template&id=19dac7ed&"
import script from "./IconContrast.vue?vue&type=script&lang=ts&"
export * from "./IconContrast.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports